import type { AxiosResponse } from "axios";

import type { CancelableAxiosPromise, S3PutSuccess } from "./base";
import { baseService } from "./base";

export const userService = {
  adminEdit(serviceArgs: {
    hasZeusAccess: boolean;
    id: number;
  }): Promise<AxiosResponse | S3PutSuccess> {
    const { hasZeusAccess, id } = serviceArgs;

    return baseService.put(`/api/admin/user/${id}`, {
      has_zeus_access: hasZeusAccess,
    });
  },

  login(email: string, password: string): CancelableAxiosPromise {
    return baseService.post("/api/auth", {
      email,
      password,
    });
  },

  loadCurrentUser(): CancelableAxiosPromise {
    return baseService.get("/api/user");
  },

  load(): CancelableAxiosPromise {
    return baseService.get("/api/users");
  },

  edit(
    userId: number,
    role: string,
    networkIds: number[],
    disabled: boolean,
  ): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put(`/api/user/${userId}`, {
      disabled,
      networkIds,
      role,
    });
  },

  invite(
    name: string,
    email: string,
    role: string,
    networkIds: number[],
    disabled: boolean,
  ): CancelableAxiosPromise {
    return baseService.post("/api/user/invite", {
      disabled,
      email,
      name,
      networkIds,
      role,
    });
  },

  inviteDetails(invitationId: string): CancelableAxiosPromise {
    return baseService.get(`/api/user/invite/${invitationId}`);
  },

  me(): CancelableAxiosPromise {
    return baseService.get("/api/user/me");
  },

  register(
    invitationId: string,
    name: string,
    p1: string,
    p2: string,
  ): CancelableAxiosPromise {
    return baseService.post("/api/user", {
      invitationId,
      name,
      p1,
      p2,
    });
  },

  changePassword(
    p1: string,
    p2: string,
  ): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put("/api/user", {
      p1,
      p2,
    });
  },

  forgotPassword(email: string): CancelableAxiosPromise {
    return baseService.post("/api/user/forgot-password", {
      email,
    });
  },

  resetPassword(token: string, p1: string, p2: string): CancelableAxiosPromise {
    return baseService.post("/api/user/reset-password", {
      token,
      p1,
      p2,
    });
  },

  loadSystemUsers(): CancelableAxiosPromise {
    return baseService.get("/api/admin/user/system");
  },

  systemUserLogin(sysUserId: number): CancelableAxiosPromise {
    return baseService.post(`/api/auth/system-user/${sysUserId}`);
  },
};

export default userService;
